import './Pricing.scss';
import { useEffect, useState } from 'react';
import { getAllPricing, packageState } from '../../redux/slices/PackageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FaCheck, FaTimes, FaStar } from 'react-icons/fa';
import Loader from '../../components/CommonComponents/Loader/Loader';
import { AppDispatch } from '../../redux/store';
import { useNavigate } from 'react-router';
import SignUp from '../SignUp/Signup';
import SignUpPopupHOC from '../SignUp/hoc/SignupHoc';
import SignInPopupHOC from '../Login/hoc/SigninHoc';
import { trackEvent } from '../../utils/Analytics';

interface IProps {
  showSignUpPopup: boolean;
  signUpToggleHandler: () => void;
  signInToggleHandler: () => void;
}

const Pricing = (props: IProps) => {
  const { showSignUpPopup, signInToggleHandler, signUpToggleHandler } = props;
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const packages = useSelector(packageState);
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'yearly'>(
    'monthly'
  );
  trackEvent('pricing_page_view');

  useEffect(() => {
    dispatch(getAllPricing({}));
  }, [dispatch]);
  return (
    <>
      {showSignUpPopup && (
        <SignUp
          modalClosedSignUp={signUpToggleHandler}
          modalClosedSignIn={signInToggleHandler}
        />
      )}

      <div className="pricing-page">
        {' '}
        {/* Hero */}{' '}
        <section className="pricing-hero">
          {' '}
          <div className="container">
            {' '}
            <div className="pricing-hero-content">
              {' '}
              <span className="pricing-badge">
                {' '}
                Simple & Transparent Pricing{' '}
              </span>{' '}
              <h1>
                {' '}
                Choose the Right <span> Plan for You</span>{' '}
              </h1>{' '}
              <p>
                {' '}
                List your properties, connect with tenants and grow your
                visibility with GrhamDeal. No hidden fees, just simple
                pricing.{' '}
              </p>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        {/* Pricing */}{' '}
        <section className="subscription">
          {' '}
          <div className="container">
            {' '}
            <div className="pricing-intro">
              {' '}
              <h5>Owner Plans</h5>{' '}
              <p>
                {' '}
                Tenants can browse properties and connect with owners for
                free.{' '}
              </p>{' '}
              {/* Billing Toggle */}{' '}
              <div className="billing-toggle">
                {' '}
                <button
                  type="button"
                  className={billingCycle === 'monthly' ? 'active' : ''}
                  onClick={() => setBillingCycle('monthly')}
                >
                  {' '}
                  Monthly{' '}
                </button>{' '}
                <button
                  type="button"
                  className={billingCycle === 'yearly' ? 'active' : ''}
                  onClick={() => setBillingCycle('yearly')}
                >
                  {' '}
                  Yearly <span className="save-badge"> Save More </span>{' '}
                </button>{' '}
              </div>{' '}
            </div>{' '}
            {packages.isLoading ? (
              <Loader isHomeLoader={true} />
            ) : (
              <div className="pricing-grid">
                {' '}
                {packages.data?.packages?.map((e: any) => {
                  const isRecommended = e.order === 3;
                  const isFree = e.order === 1;
                  const price = isFree
                    ? 0
                    : billingCycle === 'monthly'
                      ? e.monthlyPrice
                      : e.yearlyPrice;
                  const validity = isFree
                    ? e.items?.days
                    : billingCycle === 'monthly'
                      ? e.monthlyDays || 30
                      : e.yearlyDays || 365;
                  return (
                    <div
                      key={e._id}
                      className={`pricing-card ${isRecommended ? 'recommended' : ''}`}
                    >
                      {' '}
                      {/* Recommended */}{' '}
                      {isRecommended && (
                        <div className="recommended-badge">
                          {' '}
                          <FaStar /> Most Popular{' '}
                        </div>
                      )}{' '}
                      {/* Header */}{' '}
                      <div className="pricing-card-header">
                        {' '}
                        <div className="plan-icon">
                          {' '}
                          {isFree
                            ? '🌱'
                            : e.order === 2
                              ? '🚀'
                              : e.order === 3
                                ? '⭐'
                                : '👑'}{' '}
                        </div>{' '}
                        <h3>{e.name}</h3>{' '}
                        <p className="plan-description">
                          {' '}
                          {isFree
                            ? 'Perfect for getting started'
                            : e.order === 2
                              ? 'For small property owners'
                              : e.order === 3
                                ? 'Best value for active owners'
                                : 'For owners with multiple properties'}{' '}
                        </p>{' '}
                      </div>{' '}
                      {/* Price */}{' '}
                      <div className="plan-price-wrapper">
                        {' '}
                        <span className="currency">
                          {' '}
                          {e.currency?.toLowerCase() === 'inr' ? '₹' : '$'}{' '}
                        </span>{' '}
                        <span className="plan-price"> {price} </span>{' '}
                        <span className="price-period">
                          {' '}
                          {isFree
                            ? ' / free'
                            : billingCycle === 'monthly'
                              ? ' / month'
                              : ' / year'}{' '}
                        </span>{' '}
                      </div>{' '}
                      {/* Yearly savings */}{' '}
                      {!isFree && billingCycle === 'yearly' && (
                        <div className="yearly-saving">
                          {' '}
                          Save more with annual billing{' '}
                        </div>
                      )}{' '}
                      <div className="plan-divider" /> {/* Features */}{' '}
                      <ul className="plan-features">
                        {' '}
                        <li>
                          {' '}
                          <FaCheck />{' '}
                          <span>
                            {' '}
                            <strong> {e.items?.propertyListing} </strong>{' '}
                            Rent/Sell Property Listings{' '}
                          </span>{' '}
                        </li>{' '}
                        <li>
                          {' '}
                          <FaCheck />{' '}
                          <span>
                            {' '}
                            <strong>{validity}</strong> Days Validity{' '}
                          </span>{' '}
                        </li>{' '}
                        <li
                          className={
                            !e.items?.featureProperty ? 'disabled' : ''
                          }
                        >
                          {' '}
                          {e.items?.featureProperty ? (
                            <FaCheck />
                          ) : (
                            <FaTimes />
                          )}{' '}
                          <span>
                            {' '}
                            {e.items?.featureProperty ? (
                              <>
                                {' '}
                                <strong>
                                  {' '}
                                  {e.items?.featurePropertyNumber}{' '}
                                </strong>{' '}
                                Featured Properties{' '}
                              </>
                            ) : (
                              'Featured Properties'
                            )}{' '}
                          </span>{' '}
                        </li>{' '}
                        <li className={!e.items?.chat ? 'disabled' : ''}>
                          {' '}
                          {e.items?.chat ? <FaCheck /> : <FaTimes />}{' '}
                          <span> Chat with Tenant </span>{' '}
                        </li>{' '}
                        <li>
                          {' '}
                          <FaCheck />{' '}
                          <span>
                            {' '}
                            <strong>{e.items?.photos}</strong> Photos per
                            Property{' '}
                          </span>{' '}
                        </li>{' '}
                        <li
                          className={!e.items?.youtubeVideo ? 'disabled' : ''}
                        >
                          {' '}
                          {e.items?.youtubeVideo ? (
                            <FaCheck />
                          ) : (
                            <FaTimes />
                          )}{' '}
                          <span> YouTube Video Link </span>{' '}
                        </li>{' '}
                        <li className={!e.items?.support ? 'disabled' : ''}>
                          {' '}
                          {e.items?.support ? <FaCheck /> : <FaTimes />}{' '}
                          <span> Customer Support </span>{' '}
                        </li>{' '}
                      </ul>{' '}
                      {/* Footer */}{' '}
                      <div className="plan-footer">
                        {' '}
                        {/* {isFree ? (
                          <button
                            className="choose-plan-btn"
                            onClick={signUpToggleHandler}
                          >
                            Free to Get Started
                          </button>
                        ) : (
                          <button
                            className="choose-plan-btn"
                            onClick={signUpToggleHandler}
                          >
                            Choose {e.name.replace(' Plan', '')}
                          </button>
                        )} */}
                      </div>{' '}
                    </div>
                  );
                })}{' '}
              </div>
            )}{' '}
            <div className="pricing-note">
              {' '}
              <span>🔒</span>{' '}
              <p> Secure payments • No hidden charges • Quick support </p>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
      </div>
    </>
  );
};

export default SignUpPopupHOC(SignInPopupHOC(Pricing));
